import actionTypes from '../constants/action-types';

const hideEditor = () => ({
  type: actionTypes.HIDE_EDITOR,
});

export default hideEditor;
